import Header from "@/components/Header";
import { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Privatlivspolitik</h1>
        
        <div className="prose prose-slate max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mb-4">1. Introduktion</h2>
            <p className="text-muted-foreground">
              Denne privatlivspolitik beskriver, hvordan SharePark ("vi", "os", "vores") indsamler, 
              bruger og beskytter dine personoplysninger, når du bruger vores platform til deling 
              af parkeringspladser.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">2. Dataansvarlig</h2>
            <p className="text-muted-foreground">
              SharePark<br />
              CVR: 46000439<br />
              Email: askyum@hotmail.com<br />
              Telefon: [Indsæt telefonnummer]
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">3. Hvilke oplysninger indsamler vi?</h2>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li><strong>Kontooplysninger:</strong> Navn, email, telefonnummer, profilbillede</li>
              <li><strong>Betalingsoplysninger:</strong> Behandles af Stripe, vi gemmer ikke kortoplysninger</li>
              <li><strong>Parkeringsoplysninger:</strong> Adresse, fotos, faciliteter, priser</li>
              <li><strong>Bookingoplysninger:</strong> Dato, tid, beløb, status</li>
              <li><strong>Kommunikation:</strong> Beskeder mellem brugere</li>
              <li><strong>Tekniske oplysninger:</strong> IP-adresse, browser type, enhedsoplysninger</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">4. Hvordan bruger vi dine oplysninger?</h2>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Levere og administrere vores tjenester</li>
              <li>Behandle betalinger og bookinger</li>
              <li>Kommunikation mellem udlejere og lejere</li>
              <li>Forbedre vores platform og brugeroplevelse</li>
              <li>Forebygge bedrageri og misbrug</li>
              <li>Overholde juridiske forpligtelser</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">5. Deling af oplysninger</h2>
            <p className="text-muted-foreground mb-4">
              Vi deler dine oplysninger med:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li><strong>Andre brugere:</strong> Når du booker eller udlejer en parkeringsplads</li>
              <li><strong>Stripe:</strong> Til behandling af betalinger</li>
              <li><strong>Supabase:</strong> Vores cloud database udbyder</li>
              <li><strong>Resend:</strong> Til afsendelse af emails</li>
              <li><strong>Myndighederne:</strong> Når det er juridisk påkrævet</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">6. Opbevaring af data</h2>
            <p className="text-muted-foreground">
              Vi opbevarer dine personoplysninger så længe din konto er aktiv, eller så længe 
              det er nødvendigt for at levere vores tjenester. Bogføringsdata opbevares i 
              minimum 5 år iht. bogføringsloven.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">7. Dine rettigheder</h2>
            <p className="text-muted-foreground mb-4">
              Du har ret til at:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Få indsigt i dine personoplysninger</li>
              <li>Få rettet ukorrekte oplysninger</li>
              <li>Få slettet dine oplysninger (ret til at blive glemt)</li>
              <li>Gøre indsigelse mod behandling</li>
              <li>Få dine data udleveret (dataportabilitet)</li>
              <li>Trække samtykke tilbage</li>
              <li>Klage til Datatilsynet</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">8. Sikkerhed</h2>
            <p className="text-muted-foreground">
              Vi implementerer passende tekniske og organisatoriske sikkerhedsforanstaltninger 
              for at beskytte dine personoplysninger mod uautoriseret adgang, tab eller 
              ødelæggelse. Dette inkluderer kryptering, adgangskontrol og regelmæssige 
              sikkerhedsvurderinger.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">9. Cookies</h2>
            <p className="text-muted-foreground">
              Vi bruger cookies til at forbedre din oplevelse. Se vores cookie-banner for 
              detaljer om hvilke cookies vi bruger og hvordan du kan administrere dine 
              præferencer.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">10. Børn</h2>
            <p className="text-muted-foreground">
              Vores tjeneste er ikke beregnet til personer under 18 år. Vi indsamler ikke 
              bevidst personoplysninger fra børn under 18 år.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">11. Ændringer</h2>
            <p className="text-muted-foreground">
              Vi kan opdatere denne privatlivspolitik fra tid til anden. Væsentlige ændringer 
              vil blive meddelt via email eller en meddelelse på platformen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">12. Kontakt</h2>
            <p className="text-muted-foreground">
              Har du spørgsmål til vores privatlivspolitik, kan du kontakte os på:<br />
              Email: privacy@sharepark.dk<br />
              Telefon: [Indsæt telefonnummer]
            </p>
          </section>

          <p className="text-sm text-muted-foreground mt-8">
            Sidst opdateret: {new Date().toLocaleDateString('da-DK')}
          </p>
        </div>
      </main>
    </div>
  );
}
